import React, { useReducer, useState } from "react";
import Password from "../Components/Login/Password";
import Username from "../Components/Login/Username";
import Logo from "../assets/img/flexihours-logo.jpg";
import useLocalStorage from "../Hooks/useLocalStorage";

const initialState = {
  username: "",
  password: "",
};

const AdminAccess = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [adminData, setAdminData] = useLocalStorage("adminData", "");
  const [showPassword, setShowPassword] = useState(false);
  const [showComponent, setShowComponent] = useState({
    user: true,
    password: false,
  });

  function reducer(state, action) {
    switch (action.type) {
      case "UPDATE":
        return {
          ...state,
          [action.key]: action.value,
        };
      default:
        return state;
    }
  }

  return (
    <div className="h-screen w-screen">
      <div className="flex flex-col h-full items-center w-full mt-44">
        <img src={Logo} className="h-16 w-fit mb-16" />
        <div className="flex flex-col border border-[#ADD8E6] rounded-lg w-[470px] items-center py-6 px-12">
          <p className="text-3xl tracking-wider">Admin Access</p>
          {showComponent.user && (
            <Username
              state={state}
              dispatch={dispatch}
              setShowComponent={setShowComponent}
              setAdminData={setAdminData}
            />
          )}

          {showComponent.password && (
            <Password
              state={state}
              dispatch={dispatch}
              adminData={adminData}
              setAdminData={setAdminData}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminAccess;
